import { ApplicationApi } from 'api';

export const endCustomerKeys = {
	all: ['endCustomer'] as const,
	customer: (id: number) => [...endCustomerKeys.all, 'customer', id] as const,
};

export const getEndCustomerQuery = (api: ApplicationApi, id: number) => ({
	queryKey: endCustomerKeys.customer(id),
	queryFn: async () => (await api.getEndCustomer({ endCustomerId: id })).data,
});

export const EMAIL_ALREADY_USED_EXCEPTION = 'EmailAlreadyUsedException';
